import React, { useState, useEffect } from "react";
import "./RestaurantApprovals.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines } from "@fortawesome/free-solid-svg-icons";
import ViewDocument from "../components/viewDocument";
import AssignPopup from "../components/AssignPopup";
import RestaurantDetailsModal from "../components/RestaurantDetailsModal";
import { 
  useApplications,
  useAssignARM,
  useARMUsers,
  useApplicationDetails
} from "../../hooks/useApplications";
import { useDataRefresh } from "../../hooks/useDataRefresh";
import { useRestaurantsForManagement } from "../../hooks/useRestaurantManagement";
import MenuVerification from "../MenuVerification/MenuVerification";
//import api from "../../services/api";

const RestaurantApprovals = () => {
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [activeSection, setActiveSection] = useState("myTickets");
  const [showAssignDropdown, setShowAssignDropdown] = useState(null);
  const [showHeaderDropdown, setShowHeaderDropdown] = useState(false);
  const [showAssignPopup, setShowAssignPopup] = useState(false);
  const [selectedRestaurantForAssign, setSelectedRestaurantForAssign] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedRestaurantId, setSelectedRestaurantId] = useState(null);
  const [userDesignation, setUserDesignation] = useState('RM');
  const [selectedRestaurantForVerification, setSelectedRestaurantForVerification] = useState(null);
  const canAccessRestaurantManagement = true;
  
  // React Query hooks
  const { data: restaurants = [], isLoading } = useApplications();
  const { data: armUsers = [] } = useARMUsers();
  const { data: applicationDetails } = useApplicationDetails(selectedRestaurantId);
  const assignARMMutation = useAssignARM();
  const { data: managementRestaurants = [], isLoading: isManagementLoading } =
      useRestaurantsForManagement(
      activeSection === "menuVerification" && canAccessRestaurantManagement
    );
  
  // Data refresh hook
  const { refreshAllData } = useDataRefresh();
  
  // Get user designation from localStorage
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        setUserDesignation(userData.designation || 'RM');
        console.log('User data from localStorage:', userData);
        console.log('User designation:', userData.designation);
      } catch (error) {
        console.error('Error parsing user data:', error);
        setUserDesignation('RM');
      }
    }
  }, []);

  useEffect(() => {
    if (activeSection === "menuVerification" && !canAccessRestaurantManagement) {
      setActiveSection("myTickets");
      setSelectedRestaurantForVerification(null);
    }
  }, [activeSection, canAccessRestaurantManagement]);

  // Debug effect to log restaurants data
  useEffect(() => {
    //console.log('Restaurants data updated:', restaurants);
    //console.log('Restaurants length:', restaurants?.length);
    if (restaurants?.length > 0) {
      console.log('First restaurant stage:', restaurants[0]?.currentStage);
    }
  }, [restaurants]);



  // Function to handle ticket assignment
  const handleAssign = (restaurantId, userId) => {
    assignARMMutation.mutate({ applicationId: restaurantId, armId: userId });
    setShowAssignDropdown(null);
    setShowHeaderDropdown(false);
  };

  const handleAssignClick = (restaurant) => {
    setSelectedRestaurantForAssign(restaurant);
    setShowAssignPopup(true);
  };

  const handlePopupAssign = (userId, action) => {
    if (action === 'assign' && selectedRestaurantForAssign && userId) {
      assignARMMutation.mutate({ applicationId: selectedRestaurantForAssign._id, armId: userId });
    } else if (action === 'reject') {
      // Handle reject/cancel action
      refreshAllData();
    }
    setShowAssignPopup(false);
    setSelectedRestaurantForAssign(null);
  };

  const handleViewDetails = (restaurant) => {
    setSelectedRestaurantId(restaurant._id);
    setShowDetailsModal(true);
  };

  const handleARMAction = async (applicationId, action, rejectionReason = null) => {
    // This function is kept for backward compatibility but will be handled by Redux in the modal
    setShowDetailsModal(false);
  };

  // Function to format date
  const formatDate = (date) => {
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    return new Date(date).toLocaleDateString("en-GB", options);
  };

  // Function to determine status display
  const getStatusDisplay = (status) => {
    if (status === true) return { text: "Approved", className: "approved" };
    if (status === false) return { text: "Pending", className: "pending" };
    if (status === "new") return { text: "New", className: "new" };
    if (status === "cancelled") return { text: "Rejected", className: "rejected" };
    return { text: "Approved", className: "new" };
  };

  // Function to filter restaurants based on section
  const filterRestaurants = (restaurants) => {
    if (!restaurants) return [];
    
    console.log('Filtering restaurants:', restaurants.length, 'total');
    console.log('Active section:', activeSection);
    console.log('User designation:', userDesignation);
    
    const filtered = restaurants.filter(restaurant => {
      const currentStage = restaurant.currentStage;
      console.log('Restaurant stage:', currentStage, 'for restaurant:', restaurant._id);

      switch (activeSection) {
        case "requests":
          if (userDesignation === 'ARM') {
            return currentStage === "ARM_REVIEW";
          } else if (userDesignation === 'RM') {
            return currentStage === "RM_REVIEW" ;
          }
          return false;
        case "approved":
          return currentStage === "APPROVED";
        case "rejected":
          return currentStage === "REJECTED";
        case "myTickets":
          if (userDesignation === 'ARM') {
            return currentStage === "ARM_REVIEW";
          } else if (userDesignation === 'RM') {
            return currentStage === "RM_REVIEW";
          }
          return currentStage === "TL_REVIEW";
        default:
          return true;
      }
    });
    
    console.log('Filtered restaurants:', filtered.length, 'after filtering');
    return filtered;
  };

  const getTableHeaders = () => {
    if (activeSection === "requests") {
      return (
        <tr>
          <th>Case No.</th>
          <th>Restaurant Name</th>
          <th>Location</th>
          <th>Req. Date</th>
          <th>Status</th>
          <th>Documents</th>
          <th>Total Amt.</th>
          <th>Payment</th>
          <th className="assign-container">
            {userDesignation === 'ARM' ? (
              <div>View</div>
            ) : (
              <div onClick={() => setShowHeaderDropdown(!showHeaderDropdown)}>
                Assign
                {showHeaderDropdown && renderAssignDropdown('header')}
              </div>
            )}
          </th>
        </tr>
      );
    } else if (activeSection === "myTickets") {
      return (
        <tr>
          <th>Case No.</th>
          <th>Restaurant Name</th>
          <th>Location</th>
          <th>Req. Date</th>
          <th>Status</th>
          <th>Documents</th>
          <th>Total Amt.</th>
          <th>Payment</th>
          {userDesignation === 'ARM' ? (
            <th>Action</th>
          ) : (
            <>
              <th className="assign-container">
                <div onClick={() => setShowHeaderDropdown(!showHeaderDropdown)}>
                  Assign
                  {showHeaderDropdown && renderAssignDropdown('header')}
                </div>
              </th>
              <th>View</th>
            </>
          )}
        </tr>
      );
    } else {
      return (
        <tr>
          <th>Case No.</th>
          <th>Restaurant Name</th>
          <th>Status</th>
        </tr>
      );
    }
  };

  const renderAssignDropdown = (restaurantId) => (
    <div className="assign-dropdown">
      {armUsers.map((user) => (
        <div
          key={user._id}
          className="assign-option"
          onClick={() => handleAssign(restaurantId, user._id)}
        >
          {user.name}
        </div>
      ))}
    </div>
  );

  return (
    <div className="dashboard-container">
      <div className="content">
        <h1 className="dashboard-title">Restaurants-approvals</h1>
        <div className="sts">
          {/* <div
            className={`status-card ${activeSection === "requests" ? "active" : ""}`}
            onClick={() => setActiveSection("requests")}
            style={activeSection === "requests" ? { backgroundColor: "#F8951D", color: "white" } : {}}>
            <span style={activeSection === "requests" ? { color: "white" } : {}}>
              {userDesignation === 'ARM' ? 'My Applications' : 'Requests'}
            </span>
          </div> */}
          <div
            className={`status-card ${activeSection === "myTickets" ? "active" : ""}`}
            onClick={() => setActiveSection("myTickets")}
            style={activeSection === "myTickets" ? { backgroundColor: "#F8951D", color: "white" } : {}}>
            <span style={activeSection === "myTickets" ? { color: "white" } : {}}>My Tickets</span>
          </div>
          <div
            className={`status-card ${activeSection === "approved" ? "active" : ""}`}
            onClick={() => setActiveSection("approved")}
            style={activeSection === "approved" ? { backgroundColor: "#F8951D", color: "white" } : {}}>
            <span style={activeSection === "approved" ? { color: "white" } : {}}>Approved</span>
          </div>
          <div
            className={`status-card ${activeSection === "rejected" ? "active" : ""}`}
            onClick={() => setActiveSection("rejected")}
            style={activeSection === "rejected" ? { backgroundColor: "#F8951D", color: "white" } : {}}>
            <span style={activeSection === "rejected" ? { color: "white" } : {}}>Rejected</span>
          </div>
          {canAccessRestaurantManagement ? (
            <div
              className={`status-card ${activeSection === "menuVerification" ? "active" : ""}`}
              onClick={() => {
                setActiveSection("menuVerification");
                setSelectedRestaurantForVerification(null);
              }}
              style={activeSection === "menuVerification" ? { backgroundColor: "#F8951D", color: "white" } : {}}
            >
              <span style={activeSection === "menuVerification" ? { color: "white" } : {}}>
                Menu Verification
              </span>
            </div>
          ) : null}
        </div>

        {activeSection === "menuVerification" && selectedRestaurantForVerification ? (
          <MenuVerification
            restaurantId={selectedRestaurantForVerification}
            onBack={() => setSelectedRestaurantForVerification(null)}
          />
        ) : activeSection === "menuVerification" ? (
          <table className="dashboard-table">
            <thead>
              <tr>
                <th>Restaurant Name</th>
                <th>City</th>
                <th>Phone</th>
                <th>Menu Verification</th>
              </tr>
            </thead>
            <tbody>
              {isManagementLoading ? (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center", padding: "20px" }}>Loading...</td>
                </tr>
              ) : managementRestaurants.length === 0 ? (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center", padding: "20px" }}>No restaurants available</td>
                </tr>
              ) : (
                managementRestaurants.map((restaurant) => (
                  <tr key={restaurant._id}>
                    <td>{restaurant.restaurantName || "N/A"}</td>
                    <td>{restaurant.city || "N/A"}</td>
                    <td>{restaurant.restaurantPhoneNumber || "N/A"}</td>
                    <td>
                      <button
                        className="view-btn"
                        onClick={() => setSelectedRestaurantForVerification(restaurant._id)}>
                        View Menu
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        ) : (
        <table className="dashboard-table">
          <thead>
            {getTableHeaders()}
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="9" style={{ textAlign: 'center' }}>Loading...</td>
              </tr>
            ) : (() => {
              const filteredRestaurants = filterRestaurants(restaurants);
              console.log('Rendering restaurants:', filteredRestaurants.length);
              return filteredRestaurants && filteredRestaurants.length > 0 ? (
                filteredRestaurants.map((restaurant) => {
              const currentStage = restaurant.currentStage || "APPLICATION_CREATED";
              
              if (activeSection === "requests") {
                return (
                  <tr key={restaurant._id}>
                    <td>#{restaurant.caseNumber || restaurant._id}</td>
                    <td>{restaurant.restaurantId?.restaurantName || restaurant.ownerDetails?.ownerName || 'N/A'}</td>
                    <td>{restaurant.restaurantId?.restaurantAddress?.city || restaurant.restaurantId?.restaurantAddress?.area || 'N/A'}</td>
                    <td>{formatDate(restaurant.createdAt || new Date())}</td>
                    <td>
                      <span className="status pending">
                        Pending Verification
                      </span>
                    </td>
                    <td>
                      <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <FontAwesomeIcon 
                          icon={faFileLines} 
                          style={{ cursor: 'pointer', color: '#F8951D' }}
                          onClick={() => {
                            console.log('View documents for:', restaurant._id);
                          }}
                        />
                        {restaurant.documentCount || 0}
                      </span>
                    </td>
                    <td>0</td>
                    <td>Pending</td>
                    <td>
                      {userDesignation === 'ARM' ? (
                        <button
                          className="view-btn"
                          onClick={() => handleViewDetails(restaurant)}
                        >
                          View
                        </button>
                      ) : (
                        <>
                          <button
                            className="view-btn"
                            onClick={() => handleAssignClick(restaurant)}
                            style={{marginRight: "10px"}}
                          >
                            Assign
                          </button>
                          <button
                            className="view-btn"
                            onClick={() => handleViewDetails(restaurant)}
                          >
                            View
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                );
              } else if (activeSection === "myTickets") {
                return (
                  <tr key={restaurant._id}>
                    <td>#{restaurant.caseNumber || restaurant._id}</td>
                    <td>{restaurant.restaurantId?.restaurantName || restaurant.ownerDetails?.ownerName || 'N/A'}</td>
                    <td>{restaurant.restaurantId?.restaurantAddress?.city || restaurant.restaurantId?.restaurantAddress?.area || 'N/A'}</td>
                    <td>{formatDate(restaurant.createdAt || new Date())}</td>
                    <td>
                      <span className="status pending">
                        Pending Verification
                      </span>
                    </td>
                    <td>
                      <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <FontAwesomeIcon 
                          icon={faFileLines} 
                          style={{ cursor: 'pointer', color: '#F8951D' }}
                        />
                        {restaurant.documentCount || 0}
                      </span>
                    </td>
                    <td>0</td>
                    <td>Pending</td>
                    {userDesignation === 'ARM' ? (
                      <td>
                        <button
                          className="view-btn"
                          onClick={() => handleViewDetails(restaurant)}
                        >
                          View
                        </button>
                      </td>
                    ) : (
                      <>
                        <td>
                          <button
                            className="assign-btn"
                            onClick={() => handleAssignClick(restaurant)}
                          >
                            Assign
                          </button>
                        </td>
                        <td>
                          <button
                            className="view-btn"
                            onClick={() => handleViewDetails(restaurant)}
                          >
                            View
                          </button>
                        </td>
                      </>
                    )}
                  </tr>
                );
              } else {
                return (
                  <tr key={restaurant._id}>
                    <td>#{restaurant.caseNumber || restaurant._id}</td>
                    <td>{restaurant.restaurantId?.restaurantName || restaurant.ownerDetails?.ownerName || "N/A"}</td>
                    <td>
                      <span className={`status ${getStatusDisplay(currentStage).className}`}>
                        {getStatusDisplay(currentStage).text}
                      </span>
                    </td>
                  </tr>
                );
              }
              })
              ) : (
                <tr>
                  <td colSpan={userDesignation === 'ARM' ? (activeSection === "myTickets" ? "9" : "3") : (activeSection === "myTickets" ? "10" : activeSection === "requests" ? "9" : "3")} style={{textAlign: 'center', padding: '20px'}}>
                    No restaurant data available for {activeSection} section (User: {userDesignation})
                  </td>
                </tr>
              );
            })()}
          </tbody>
        </table>
        )}
        {selectedRestaurant && (
          <ViewDocument
            restaurant={selectedRestaurant}
            documents={selectedDocs}
            onClose={() => setSelectedRestaurant(null)}
          />
        )}
        
        <AssignPopup
          isOpen={showAssignPopup}
          onClose={() => setShowAssignPopup(false)}
          onAssign={handlePopupAssign}
          armUsers={armUsers}
          userDesignation={userDesignation}
        />
        
        {showDetailsModal && applicationDetails && (
          <RestaurantDetailsModal
            open={showDetailsModal}
            onClose={() => {
              setShowDetailsModal(false);
              setSelectedRestaurantId(null);
            }}
            data={applicationDetails}
            userDesignation={userDesignation}
            onARMAction={handleARMAction}
          />
        )}
      </div>
    </div>
  );
};

export default RestaurantApprovals;
